<template>
  <v-main>
    <v-container>
      <v-toolbar class="elevation-0">
        <v-toolbar-title class="pl-0 ml-n4">{{ (id) ? 'Editar' : 'Adicionar' }} Arrecadação</v-toolbar-title>
      </v-toolbar>
      <v-alert type="error" v-if="errorMessage" class="mb-6">{{ errorMessage }}</v-alert>
      <v-form ref="form" @submit.prevent>
        <v-row>
          <v-col md="6">
            <v-text-field
              label="Nome"
              v-model="fields.name.value"
              :rules="[...fields.name.rules, ...fields.name.apiErrors]"
              type="text"
              @input="fields.name.apiErrors = []"
              outlined dense
            ></v-text-field>
            <v-textarea
              label="Descrição"
              v-model="fields.description.value"
              :rules="[...fields.description.rules, ...fields.description.apiErrors]"
              @input="fields.description.apiErrors = []"
              outlined
            ></v-textarea>
            <!-- <v-file-input
              accept="image/*"
              label="Imagem"
              :rules="[...fields.image.rules, ...fields.image.apiErrors]"
              prepend-icon=""
              prepend-inner-icon="mdi-camera"
              outlined dense
              v-model="fields.image.value"
              placeholder="Trocar a imagem"
              @change="newFile"
            ></v-file-input>
            <img v-if="fields.image.url" :src="fields.image.url" class="preview-image" /> -->
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="3">
            <v-text-field
              label="Quantidade de pessoas"
              v-model="fields.people_quantity.value"
              :rules="[...fields.people_quantity.rules, ...fields.people_quantity.apiErrors]"
              type="number"
              @input="fields.people_quantity.apiErrors = []"
              outlined dense
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="3">
            <decimal-number
              label="Valor por pessoa"
              v-model="fields.unit_price.value"
              :rules="[...fields.unit_price.apiErrors]"
              @input="fields.unit_price.apiErrors = []"
              outlined dense
            ></decimal-number>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="3">
            <v-menu
              ref="start_date_menu"
              v-model="fields.start_date.menu"
              :close-on-content-click="false"
              :return-value.sync="fields.start_date.value"
              transition="scale-transition"
              offset-y min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  label="Inicia em"
                  :value="(fields.start_date.value && $moment(fields.start_date.value, 'YYYY-MM').format('MM/YYYY')) || ''"
                  :rules="[...fields.start_date.rules, ...fields.start_date.apiErrors]"
                  type="text"
                  prepend-inner-icon="mdi-calendar-blank"
                  readonly
                  @input="fields.start_date.apiErrors = []"
                  v-on="on"
                  outlined dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fields.start_date.value"
                no-title scrollable
                type="month"
                :max="fields.finish_date.value"
                locale="pt-br"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="fields.start_date.menu = false">Cancelar</v-btn>
                <v-btn text color="primary" @click="$refs.start_date_menu.save(fields.start_date.value)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="6" md="3">
            <v-menu
              ref="finish_date_menu"
              v-model="fields.finish_date.menu"
              :close-on-content-click="false"
              :return-value.sync="fields.finish_date.value"
              transition="scale-transition"
              offset-y min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  label="Termina em"
                  :value="(fields.finish_date.value && $moment(fields.finish_date.value, 'YYYY-MM').format('MM/YYYY')) || ''"
                  :rules="[...fields.finish_date.rules, ...fields.finish_date.apiErrors]"
                  type="text"
                  prepend-inner-icon="mdi-calendar-blank"
                  readonly
                  @input="fields.finish_date.apiErrors = []"
                  v-on="on"
                  outlined dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fields.finish_date.value"
                no-title scrollable
                type="month"
                :min="fields.start_date.value"
                locale="pt-br"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="fields.finish_date.menu = false">Cancelar</v-btn>
                <v-btn text color="primary" @click="$refs.finish_date_menu.save(fields.finish_date.value)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-btn color="success" :disabled="sending" :loading="sending" @click="send()">Salvar</v-btn>
        <v-btn text color="error" :disabled="sending" @click="$router.go(-1)">Cancelar</v-btn>
      </v-form>
    </v-container>
    <app-loading :visible="loading"></app-loading>
  </v-main>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'
import AppLoading from '@/components/Loading'
import DecimalNumber from '@/components/DecimalNumber'

export default {
  name: 'fundraisingForm',
  components: {
    AppLoading,
    DecimalNumber
  },
  props: ['id', 'celebrationId'],
  data: () => ({
    loading: false,
    fields: {
      name: {
        value: '',
        rules: [
          v => !!v || 'O nome é obrigatório'
        ],
        apiErrors: []
      },
      description: {
        value: '',
        rules: [
          v => !!v || 'O convite é obrigatório'
        ],
        apiErrors: []
      },
      image: {
        value: null,
        url: '',
        rules: [],
        apiErrors: []
      },
      people_quantity: {
        value: 0,
        rules: [
          v => !!v || 'O quantidade de pessoas é obrigatória',
          v => v > 0 || 'Precisa ser maior do que 0'
        ],
        apiErrors: []
      },
      unit_price: {
        value: 0,
        rules: [
          v => !!v || 'O valor por pessoa é obrigatório',
          v => v > 0 || 'Precisa ser maior do que 0'
        ],
        apiErrors: []
      },
      start_date: {
        value: null,
        menu: false,
        rules: [
          v => !!v || 'A data inicial é obrigatória'
        ],
        apiErrors: []
      },
      finish_date: {
        value: null,
        menu: false,
        rules: [
          v => !!v || 'A data final é obrigatória'
        ],
        apiErrors: []
      }
    },
    sending: false,
    errorMessage: null
  }),
  computed: {
    apiData () {
      let data = new FormData()
      for (let key in this.fields) {
        if (key === 'start_date' || key === 'finish_date') data.append(key, this.fields[key].value + '-01')
        else if (this.fields[key].value) data.append(key, this.fields[key].value)
      }
      if (this.id) data.append('_method', 'patch')
      else data.append('celebration_id', this.celebrationId)
      return data
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    newFile (file) {
      let reader = new FileReader()
      reader.onloadend = () => { this.fields.image.url = reader.result }
      if (file) reader.readAsDataURL(file)
      else this.fields.image.url = ''
    },
    generateApiErrors (apiErrors) {
      for (let key in apiErrors) {
        if (this.fields[key]) this.fields[key].apiErrors = apiErrors[key]
      }
    },
    send () {
      let vue = this

      if (vue.$refs.form.validate()) {
        vue.sending = true
        vue.errorMessage = null
        let url = (vue.id) ? 'fundraisings/' + vue.id : 'fundraisings'

        axios(url, {
          method: 'post',
          data: vue.apiData
        })
          .then(response => {
            if (response) {
              vue.sending = false
              vue.SET_SNACKBAR({ text: (vue.id) ? 'Arrecadação atualizada' : 'Arrecadação adicionada' })
              vue.$router.go(-1)
            }
          })
          .catch(error => {
            if (error.response && error.response.status === 422) {
              if (error.response.data) vue.generateApiErrors(error.response.data)
              vue.errorMessage = 'Verifique os campos com erro'
            } else {
              vue.errorMessage = 'Houve um erro ao processar seu pedido, por favor contacte o suporte técnico'
            }
            vue.sending = false
          })
      } else {
        vue.errorMessage = 'Verifique os campos com erro'
      }
    }
  },
  created () {
    if (this.id) {
      let vue = this
      vue.loading = true

      axios.get('fundraisings/' + vue.id)
        .then(response => {
          if (response.data) {
            vue.loading = false
            for (let key in vue.fields) {
              if (key === 'image') vue.fields[key].url = response.data[key]
              if (key === 'start_date' || key === 'finish_date') vue.fields[key].value = response.data[key].substr(0, 7)
              else if (response.data[key]) vue.fields[key].value = response.data[key]
            }
          } else {
            vue.loading = false
            vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
            vue.$router.go(-1)
          }
        })
        .catch(() => {
          vue.loading = false
          vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
          vue.$router.go(-1)
        })
    }
  }
}
</script>
